class TurnoSemanal {
  constructor({
    id = null,
    nombre = '',
    
    lunes = null,
    martes = null,
    miercoles = null,
    jueves = null,
    viernes = null,
    sabado = null,
    domingo = null,

    lunes_id = null,
    martes_id = null,
    miercoles_id = null,
    jueves_id = null,
    viernes_id = null,
    sabado_id = null,
    domingo_id = null,
  }) {
    this.id = id;
    this.nombre = nombre;

    // Campos anidados (legibles)
    this.lunes = lunes;
    this.martes = martes;
    this.miercoles = miercoles;
    this.jueves = jueves;
    this.viernes = viernes;
    this.sabado = sabado;
    this.domingo = domingo;

    // Campos para enviar al backend
    this.lunes_id = lunes_id;
    this.martes_id = martes_id;
    this.miercoles_id = miercoles_id;
    this.jueves_id = jueves_id;
    this.viernes_id = viernes_id;
    this.sabado_id = sabado_id;
    this.domingo_id = domingo_id;
  }

  update(data) {
    Object.assign(this, data);
  }

  // Método útil para enviar solo lo necesario al backend (por ejemplo, en un PUT)

}

export default TurnoSemanal;
